module.exports = __webpack_public_path__ + "static/img/account-ready-1x.2f27ab3.png";